import { render, staticRenderFns } from "./Rma.vue?vue&type=template&id=765edae4&"
import script from "./Rma.vue?vue&type=script&lang=js&"
export * from "./Rma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports